import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';

import Login        from './pages/Login';
import Register     from './pages/Register';
import Home         from './pages/Home';
import Profile      from './pages/Profile';
import Explore      from './pages/Explore';
import Search       from './pages/Search';
import Messages     from './pages/Messages';
import Notifications from './pages/Notifications';
import Reels        from './pages/Reels';
import Sidebar      from './components/Sidebar';
import CreatePostModal from './components/CreatePostModal';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="page-loader">
      <div>
        <img src="https://noris.in/wp-content/uploads/2023/01/logo.png" alt="Noris"
          style={{height:40,margin:'0 auto 12px',display:'block'}}
          onError={e => e.target.style.display = 'none'} />
        <span className="spinner" style={{margin:'0 auto'}} />
      </div>
    </div>
  );
  return user ? children : <Navigate to="/login" replace />;
}

function AppLayout() {
  const [showCreate, setShowCreate] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="app-layout">
      <Sidebar onCreatePost={() => setShowCreate(true)} />
      <main className="main-content">
        <Routes>
          <Route path="/"               element={<Home key={refreshKey} />} />
          <Route path="/profile/:id"    element={<Profile />} />
          <Route path="/explore"        element={<Explore />} />
          <Route path="/search"         element={<Search />} />
          <Route path="/messages"       element={<Messages />} />
          <Route path="/notifications"  element={<Notifications />} />
          <Route path="/reels"          element={<Reels />} />
          <Route path="*"               element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {showCreate && (
        <CreatePostModal
          onClose={() => setShowCreate(false)}
          onCreated={() => setRefreshKey(k => k + 1)}
        />
      )}
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            style: { fontFamily: 'Nunito, sans-serif', fontWeight: 600, borderRadius: 12, fontSize: 14 },
            success: { iconTheme: { primary: '#E91E8C', secondary: '#fff' } },
          }}
        />
        <Routes>
          <Route path="/login"    element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
          <Route path="/*"        element={<ProtectedRoute><AppLayout /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/" replace /> : children;
}
